const initState = {
  isFetching: false,
  activeTab: 0,
  passwordError: null,
  passwordSuccess: false,
  emailError: null,
  emailSuccess: false,
};

function profile(state = initState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return initState;
    case 'SET_ACTIVE_TAB':
      return { ...state, activeTab: action.tab };
    case 'SET_INIT_STATE':
      return initState;
    case 'CHANGE_PASSWORD_REQUEST':
      return {
        ...state, isFetching: true, passwordError: null, passwordSuccess: false,
      };
    case 'CHANGE_PASSWORD_REQUEST_SUCCESS':
      return {
        ...state, isFetching: false, passwordError: null, passwordSuccess: true,
      };
    case 'CHANGE_PASSWORD_REQUEST_ERROR':
      return { ...state, isFetching: false, passwordError: action.error };
    case 'CHANGE_EMAIL_REQUEST':
      return {
        ...state, isFetching: true, emailError: null, emailSuccess: false,
      };
    case 'CHANGE_EMAIL_REQUEST_SUCCESS':
      return {
        ...state, isFetching: false, emailError: null, emailSuccess: true,
      };
    case 'CHANGE_EMAIL_REQUEST_ERROR':
      return { ...state, isFetching: false, emailError: action.error };
    default:
      return state;
  }
}

export default profile;
